import React, { useEffect } from "react";
import { useRouter } from "next/router";
import { centreApiService } from "@/src/lib/api-services/centreApiServices";
import { useHODMutation } from "@/src/lib/hooks/useHODMutation";
import Progressbar from "@/src/components/loading";

const CityView = () => {
    const router = useRouter();
    const { city_slug } = router.query;

    const getCentreSlug = useHODMutation(
        (data) => centreApiService.getCentreSlug(data),
        {
            onSuccess: (data) => {
                console.log("data", data);
                if (data?.data?.success) {
                    const centre_slug = data?.data?.data?.[0]?.quickRedirect;
                    router.push(`/locate-us/${city_slug}/${centre_slug}`);
                }
            },
            onError: (error) => {
                const responseData = error?.response?.data;
                if (responseData?.success === false) {
                    router.push("/404");
                }
            },
        }
    );

    useEffect(() => {
        if (city_slug) {
            const payload = { citySlug: city_slug };
            getCentreSlug.mutate(payload);
        }
    }, [city_slug]);

    if (getCentreSlug.isLoading) {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                }}
            >
                <Progressbar size={40} />
            </div>
        );
    }

    return <div></div>;
};

export default CityView;
